import { Tool } from './tool';
import { ToolHolder } from './tool-holder';

export class ToolTemplateTool {
  constructor(
    public hash?: string,
    public order?: number,
    public tool?: Tool,
    public toolHolder?: ToolHolder
  ) { }

  clone() {
    return new ToolTemplateTool (
      this.hash,
      this.order,
      this.tool,
      this.toolHolder
    );
  }

  get isTool() {
    return this.tool ? true : false;
  }

  get isToolHolder() {
    return this.toolHolder ? true : false;
  }

  get toolName() {
    return this.isTool ? this.tool.name : this.isToolHolder ? this.toolHolder.name : '';
  }

  get toolHash() {
    return this.isTool ? this.tool.hash : this.isToolHolder ? this.toolHolder.hash : '';
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-template-tool.ts